<app-data-table title="Documents"
                [columns]="columns"
                [fetchDataFn]="loadData"
                [exportDataFn]="exportData"
                [reloadEmitter]="reloadTable$"
                [enableGlobalSearch]="true"
                [globalFilterFields]="['district_name', 'source_file']"
                globalSearchPlaceholder="Search by district, document name"
                defaultSortField="district_name"
                [exportable]="authService.hasPermission('documents.documents.export')">
</app-data-table>
